<style scoped>

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 130;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 8px;
}
.title-wrapper {
  color: white;
  margin-bottom: 4px;
}
</style>

<template>
  <div class="overlay full-width full-height">
    <mu-row gutter>
      <mu-col span="3" v-if="nextVideo">
        <div class="title-wrapper">
          <h3>{{$t('RecommendationOverlay.next')}}</h3>
        </div>
        <mu-row gutter>
          <mu-col span="12">
            <div class="next-video-wrapper full-width">
              <MediaThumbnail 
                :media="nextVideo"
                />
            </div>
          </mu-col>
        </mu-row>
      </mu-col>
      <mu-col :span="nextVideo ? 9 : 12" v-if="recommendVideo.length">
        <div class="title-wrapper">
          <h3>{{$t('RecommendationOverlay.recommendation')}}</h3>
        </div>
        <mu-row gutter>
          <mu-col :span="nextVideo ? 4 : 3" v-for="video in recommendVideo.slice(0, nextVideo ? 6 : 8)">
            <div class="recommend-video-wrapper full-width">
              <MediaThumbnail 
                :media="video"
                />
            </div>
          </mu-col>
        </mu-row>
      </mu-col>
    </mu-row>
  </div>
</template>

<script>

import MediaThumbnail from '@/components/Media/MediaThumbnail.vue'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: 'RecommendationOverlay',
  components: {
    MediaThumbnail
  },
  props: {
    channel: {
      type: Object,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      
    }
  },
  computed: {
    mediaId() {
      return this.media._id;
    },
    folder(){
      return this.recursiveFind(this.mediaId, this.channel.children);
    },
    nextVideo() {
      if(this.folder.length > 0) {
        var index = this.folder.findIndex(i => i.type === 'media' && i.id === this.media._id);
        var video = false;
        var ended = false;
        while(index + 1 < this.folder.length && !ended) {
          if(this.folder[index + 1].type === 'media' && (this.folder[index + 1].obj.type === 'video' || this.folder[index + 1].obj.type === 'youtube' || this.folder[index + 1].obj.type === 'mp4link')) {
            video = this.folder[index + 1].obj;
            ended = true;
          }
          index++;
        }
        return video;
      } else {
        return false;
      }
    },
    recommendVideo() {
      var arr = [];
      if(this.media.hasOwnProperty('tags') && Array.isArray(this.media.tags)) {
        this.media.tags.forEach(tag => {
          var temp = this.recursiveMerge(tag, this.channel.children);
          temp.forEach(i => {
            if(-1 === arr.findIndex(j => j._id === i._id)) {
              arr.push(i);
            }
          });
        });
      }
      return arr;
    },
  },
  methods: {
    recursiveFind(id = "", children = []) {
      var c = JSON.parse(JSON.stringify(children));
      var result = false;
      var arr = [];
      var i = 0;
      while(i < children.length && !result) {
        if(typeof children[i] !== 'undefined') {
          if(children[i].id === id && children[i].type === 'media') {
            result = true;
            arr = c;
          } else if(children[i].type === 'playlist') {
            var temp = this.recursiveFind(id, children[i].children);
            if(Array.isArray(temp)) {
              arr = temp;
              result = true;
            }
          }
        }
        i++;
      }
      if(result) {
        return arr;
      } else {
        return false;
      }
    },
    recursiveMerge(tag, children = []) {
      var arr = [];
      children.forEach(child => {
        if(child.type === 'media' && child.id !== this.media._id && child.hasOwnProperty('obj') && child.obj.hasOwnProperty('tags') && Array.isArray(child.obj.tags) && child.obj.tags.includes(tag)) {
          if(child.obj.type === 'video' || child.obj.type === 'youtube' || child.obj.type === 'mp4link') {
            arr.push(child.obj);
          }
        }
        if(child.type === 'playlist') {
          var temp = this.recursiveMerge(tag, child.children);
          arr = arr.concat(temp);
        }
      });
      return arr;
    },
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
}
</script>
